import $ from "jquery";
import luxy from "luxy.js";
require("slick-carousel");
require("slick-carousel/slick/slick.css");
require("jquery-inview");

$(() => {
  //ua判定
  let ua = navigator.userAgent;
  if (
    ua.indexOf("iPhone") > 0 ||
    (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
  ) {
    // sp
    $(".p-wrapper").addClass("is-sp");
  } else if (ua.indexOf("iPad") > 0 || ua.indexOf("Android") > 0) {
    // tablet
    $(".p-wrapper").addClass("is-tablet");
  } else {
    // pc
    $(".p-wrapper").addClass("is-pc");
  }

  //top
  $(".banner-slide").slick({
    dots: true,
    arrows: true,
    centerMode: true,
    centerPadding: "3%",
  });

  //sp menu
  if (
    ua.indexOf("iPhone") > 0 ||
    (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
  ) {
    $(".p-side-menu__box > .down").on("click", (e) => {
      $(e.currentTarget).next(".p-side-menu__sub").slideToggle("fast");
      e.preventDefault();
    });
    $(".sp-ir-menu > .down").on("click", (e) => {
      $(e.currentTarget).toggleClass("is-active");
      $(e.currentTarget).next("ul").slideToggle("fast");
      e.preventDefault();
    });
  }

  if (ua.indexOf("Android") > 0) {
    $(".page-company .concept").css("mix-blend-mode", "inherit");
    $(".page-company-index .company-index-last .declaration").css(
      "mix-blend-mode",
      "inherit"
    );
    $(".page-company-index .company-index-value ul li h3").css(
      "mix-blend-mode",
      "inherit"
    );
  }

  //ir side menu
  $(".is-active").next("ul").slideDown("fast");
  $(".page-ir .p-side-menu2 .ir-menu > a").on("click", (e) => {
    if ($(e.currentTarget).hasClass("is-active")) {
      $(e.currentTarget).next("ul").slideUp("fast");
      $(e.currentTarget).removeClass("is-active");
    } else {
      $(".page-ir .p-side-menu2 .ir-menu > a").removeClass("is-active");
      $(".page-ir .p-side-menu2 .ir-menu > ul").slideUp();
      $(e.currentTarget).next("ul").slideDown("fast");
      $(e.currentTarget).addClass("is-active");
    }
    e.preventDefault();
  });

  //ir hum menu
  $(".is-active").next("ul").slideDown("fast");
  $(".page-ir .sp-ir-menu > a").on("click", (e) => {
    if ($(e.currentTarget).hasClass("is-active")) {
      $(e.currentTarget).next("ul").slideUp("fast");
      $(e.currentTarget).removeClass("is-active");
    } else {
      $(".page-ir .sp-ir-menu > a").removeClass("is-active");
      $(".page-ir .sp-ir-menu > ul").slideUp();
      $(e.currentTarget).next("ul").slideDown("fast");
      $(e.currentTarget).addClass("is-active");
    }
    e.preventDefault();
  });

  $(".ir-tab.p-tab-content__tabs a").on("click", (e) => {
    e.preventDefault();
    $(".p-tab-content__tabs li").removeClass("is-active");
    $(e.currentTarget).parent().addClass("is-active");
    $(".p-tab-content__box").hide();
    $(".p-tab-content__box .is-animated").removeClass("is-animated");
    let boxName = `.${$(e.currentTarget).attr("class")}-box`;
    $(boxName).fadeIn();
    $(boxName + " a").addClass("is-animated");
    $(boxName + " .top-sect-news__card__nolink").addClass("is-animated");
  });
  $(
    ".top-sect-news__card:visible > a, .top-sect-news__card:visible > div"
  ).addClass("is-animated");

  $(".top-sect-news__card__nolink").addClass("is-animated");

  $(".animation-target").append('<span class="target"></span>');

  $(".animation-target .target").on("inview", function (event, isInView) {
    if (isInView) {
      $(this).parent(".animation-target").addClass("is-animated");
    } else {
      //$(this).parent('.animation-target').removeClass('is-animated')
    }
  });

  $(".top-sect-game__list").on("inview", function (event, isInView) {
    if (isInView) {
      //$('.top-sect-game__img-out').addClass('is-animated')
      $(".top-sect-game__list").addClass("is-animated");
    }
  });

  $(".top-sect-business__text").on("inview", function (event, isInView) {
    if (isInView) {
      $(this).addClass("is-animated");
      $(".top-sect-business__bg").addClass("is-animated");
    }
  });

  $(".games__img").on("inview", function (event, isInView) {
    if (isInView) {
      $(this).addClass("is-animated");
    }
  });

  $(".is-pc .top-sect-game__list li:eq(0)").on({
    mouseenter: () => {
      $(".top-sect-game__img-out-1").fadeIn("fast");
    },
    mouseleave: () => {
      $(".top-sect-game__img-out").fadeOut("fast");
    },
  });
  $(".is-pc .top-sect-game__list li:eq(1)").on({
    mouseenter: () => {
      $(".top-sect-game__img-out-2").fadeIn("fast");
    },
    mouseleave: () => {
      $(".top-sect-game__img-out").fadeOut("fast");
    },
  });
  $(".is-pc .top-sect-game__list li:eq(2)").on({
    mouseenter: () => {
      $(".top-sect-game__img-out-3").fadeIn("fast");
    },
    mouseleave: () => {
      $(".top-sect-game__img-out").fadeOut("fast");
    },
  });

  let sidebarAbsoluteFlag = false;
  $(window).on("load resize", () => {
    const footerHeight = $(".p-footer").height();
    const sidebarHeight = $.makeArray($(".p-side-menu2").children()).reduce(
      (p, v) => {
        return p + v.offsetHeight * 1.5;
      },
      0
    );
    const sidebarTopMargin = $(".p-side-menu2").css("top");
    const windowHeight = $(window).height();
    if (windowHeight <= footerHeight + sidebarHeight + ~~sidebarTopMargin) {
      sidebarAbsoluteFlag = true;
    } else {
      sidebarAbsoluteFlag = false;
    }
  });

  //topへ
  $(window).on("scroll", (e) => {
    if ($(".p-wrapper").hasClass("page-company--message")) {
      if ($(e.currentTarget).scrollTop() > 200) {
        $(".c-to-top").addClass("is-shown");
        $(".scroll").fadeOut();
        $(".p-header-menu").addClass("is-moved");
        $(".p-side-menu2--2").addClass("is-moved");
        if (
          ua.indexOf("iPhone") > 0 ||
          (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
        ) {
        } else {
          //$(".p-header-menu__logo").addClass('is-hidden')
        }
      } else {
        $(".scroll").fadeIn();
        $(".p-header-menu__logo").removeClass("is-hidden");
        $(".c-to-top").removeClass("is-shown");
        $(".p-header-menu").removeClass("is-moved");
        $(".p-side-menu2--2").removeClass("is-moved");
        if (
          ua.indexOf("iPhone") > 0 ||
          (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
        ) {
        } else {
          $(".p-header-menu__logo a").fadeIn("slow");
        }
      }
      if ($(e.currentTarget).scrollTop() > 600) {
        $(".p-side-menu2").addClass("is-moved");
      } else {
        $(".p-side-menu2").removeClass("is-moved");
      }
    } else {
      if ($(e.currentTarget).scrollTop() > 200) {
        $(".c-to-top").addClass("is-shown");
        $(".scroll").fadeOut();
        if (!sidebarAbsoluteFlag) {
          $(".p-header-menu").addClass("is-moved");
          $(".p-side-menu2").addClass("is-moved");
          $(".p-side-menu2--2").addClass("is-moved");
        } else {
          $(".p-header-menu").addClass("is-moved");
          const footerHeight = $(".p-footer").height();
          const sidebarHeight = $.makeArray(
            $(".p-side-menu2").children()
          ).reduce((p, v) => {
            return p + v.offsetHeight * 1.5;
          }, 0);
          const bodyHeight = $(".p-wrapper").height();
          const targetHeight = $(e.currentTarget).scrollTop();
          const setheight =
            bodyHeight - (targetHeight + sidebarHeight + footerHeight);
          const sidebarheight = bodyHeight - (sidebarHeight + footerHeight);
          if (setheight > 0) {
            $(".p-side-menu2").addClass("is-moved");
            $(".p-side-menu2").css("top", "");
            $(".p-side-menu2--2").addClass("is-moved");
          } else {
            $(".p-side-menu2").removeClass("is-moved");
            $(".p-side-menu2").css("top", sidebarheight + 20);
            $(".p-side-menu2--2").removeClass("is-moved");
          }
        }

        if (
          ua.indexOf("iPhone") > 0 ||
          (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
        ) {
        } else {
          $(".p-header-menu__logo").addClass("is-hidden");
        }
      } else {
        $(".scroll").fadeIn();
        $(".p-header-menu__logo").removeClass("is-hidden");
        $(".c-to-top").removeClass("is-shown");
        $(".p-header-menu").removeClass("is-moved");
        $(".p-side-menu2").removeClass("is-moved");
        $(".p-side-menu2--2").removeClass("is-moved");
        if (
          ua.indexOf("iPhone") > 0 ||
          (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
        ) {
        } else {
          $(".p-header-menu__logo a").fadeIn("slow");
        }
      }
    }

    let scrollHeight = $(document).height();
    let windowGeight = $(window).height();
    let scrollPosition = $(window).height() + $(window).scrollTop();
    let footHeight = $("footer").innerHeight();

    if (scrollHeight - scrollPosition <= footHeight) {
      if (
        ua.indexOf("iPhone") > 0 ||
        (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
      ) {
        $(".c-to-top").fadeOut("fast");
        $(".newbusiness-key__mov").hide();
      } else {
        $(".c-to-top").css({
          position: "absolute",
          bottom: footHeight + 0,
          transition: "all 0s",
        });

        $(".p-side-bar").css({
          "background-color": "transparent",
        });
      }
    } else {
      if (
        ua.indexOf("iPhone") > 0 ||
        (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
      ) {
        $(".c-to-top").fadeIn("fast");
        $(".newbusiness-key__mov").show();
      } else {
        $(".c-to-top").css({
          position: "fixed",
          bottom: "0px",
          transition: "right 0.3s",
        });
        $(".p-side-bar").css({
          //"background-color": "#fff",
        });

        $(".p-side-menu2--2").css({
          //"position": "fixed",
          //"bottom": "inherit",
          //"top": "inherit"
        });
      }
    }
  });
  $(".c-to-top").on("click", (e) => {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      400
    );
    return false;
  });

  $(".side-menu-open").on("click", (e) => {
    $(e.currentTarget).toggleClass("is-active");
    $(".p-side-menu").toggleClass("is-shown");
    $(".p-header-menu__logo").toggleClass("is-hidden");
    $(".p-header-menu__lan").toggleClass("is-hidden");
    $("body").toggleClass("is-ovh");
    e.preventDefault();
  });

  //newsタブ
  let currentTab = getParam("tab");
  let currentTabBtn = `.p-tab-content__tabs a.${currentTab}`;
  let currentTabBox = `.${currentTab}-box`;

  if (currentTab) {
    $(".p-tab-content__tabs a").parent().removeClass("is-active");
    $(".p-tab-content__box").removeClass("is-shown");
    $(currentTabBtn).parent().addClass("is-active");
    $(currentTabBox).addClass("is-shown");
    $(".ir-menu:eq(0) ul li").eq(0).removeClass("is-current");
  }

  // タブ access
  $(".company-access__tab.p-tab-content__tabs a").on("click", (e) => {
    $(".p-tab-content__tabs li").removeClass("is-active");
    $(e.currentTarget).parent().addClass("is-active");
    $(".p-tab-content__box").hide();
    let boxName = `.${$(e.currentTarget).attr("class")}-box`;
    $(boxName).fadeIn();
    e.preventDefault();
  });

  $(".accessWalk-box .p-tab-content-min__box").hide();
  $(".accessWalk-box .p-tab-content-min__box").eq(0).show();
  $(".accessWalk-box ul li").eq(0).addClass("is-active");
  $(".accessWalk-box ul li").each(function () {
    $(this).on("click", function () {
      var access_index = $(".accessWalk-box ul li").index(this);
      $(".accessWalk-box ul li").removeClass("is-active");
      $(this).addClass("is-active");
      $(".accessWalk-box .p-tab-content-min__box").hide();
      $(".accessWalk-box .p-tab-content-min__box").eq(access_index).show();
    });
  });

  //印刷access
  $('.company-access__btn__print a[href^="#"]').click(function () {
    window.print();
  });

  // アコーディオン
  $(".c-btn-more").on("click", (e) => {
    $(e.currentTarget).children().toggleClass("is-active");
    $(e.currentTarget).prev(".is-hide").slideToggle(500);
    e.preventDefault();
  });

  // activitieアコーディオン
  $(".page-activities .p-inner-sub").on("click", (e) => {
    $(e.currentTarget).find(".c-btn-more__open").toggleClass("is-active");
    $(e.currentTarget).find(".c-btn-more__close").toggleClass("is-active");
    $(e.currentTarget).find(".is-hide").slideToggle(500);
    e.preventDefault();
  });

  // カンパニーモーダル
  var current_scrollY;
  $(".page-company-index .p-modal-btn").on("click", (e) => {
    current_scrollY = $(window).scrollTop();

    $(".wrap_modal").css({
      position: "fixed",
      width: "100%",
      top: -1 * current_scrollY,
    });

    $("body").append('<div class="p-modal-bg"></div>');
    $(".p-modal-bg").fadeIn("slow");
    var modal = "#" + $(e.currentTarget).attr("data-target");
    var modalInner = modal + " .company-profile__list__inner--rel";
    modalResize();
    $(modal).fadeIn("slow");

    $(".p-modal-bg, .p-modal-btn__close")
      .off()
      .click(function () {
        $(".wrap_modal").attr({
          style: "",
        });
        $("html, body").prop({
          scrollTop: current_scrollY,
        });

        $(modal).fadeOut("slow");
        $(".p-modal-bg").fadeOut("slow", () => {
          $(".p-modal-bg").remove();
        });
        setTimeout(function () {
          $(".company-profile__list").scrollTop(0);
        }, 500);
      });

    $(window).on("resize", () => {
      modalResize();
    });

    function modalResize() {
      var w = $(window).width();
      var h = $(window).height();
      var x = (w - $(modal).outerWidth(true)) / 2;
      var y = (h - $(modal).outerHeight(true)) / 2;
      $(modal).css({
        left: x + "px",
        top: y + "px",
      });
    }
    if ($(modalInner).height() > $(modal).height()) {
      $(modal).addClass("is-scrolled");
    }
  });

  // dataページ btn切り替え,
  $("#full").click(function () {
    $("#full-area").addClass("visible");
    $("#quarter-area").removeClass("visible");
  });
  $("#quarter").click(function () {
    $("#quarter-area").addClass("visible");
    $("#full-area").removeClass("visible");
    $("#full-area").removeClass("firstcheck");
  });

  //dataページ セレクトボックス選択時
  $(".summary-finance__wrap")
    .find("#yearSelect")
    .change(function () {
      var select = $(this).children("option:selected").val();
      if (select == "1") {
        $(this).next("ul").find(".consolidated-1").removeClass("hide");
      } else if (select !== "1") {
        $(this).next("ul").find(".consolidated-1").addClass("hide");
      }
      if (select == "2") {
        $(this).next("ul").find(".consolidated-2").removeClass("hide");
      } else if (select !== "2") {
        $(this).next("ul").find(".consolidated-2").addClass("hide");
      }
      if (select == "3") {
        $(this).next("ul").find(".consolidated-3").removeClass("hide");
      } else if (select !== "3") {
        $(this).next("ul").find(".consolidated-3").addClass("hide");
      }
      if (select == "4") {
        $(this).next("ul").find(".consolidated-4").removeClass("hide");
      } else if (select !== "4") {
        $(this).next("ul").find(".consolidated-4").addClass("hide");
      }
      if (select == "5") {
        $(this).next("ul").find(".consolidated-5").removeClass("hide");
      } else if (select !== "5") {
        $(this).next("ul").find(".consolidated-5").addClass("hide");
      }
    });

  // プライバシーポリシー language切り替え,
  $("#japanese").click(function () {
    $(this).addClass("is-active");
    $("#english").removeClass("is-active");
    $(".policy__japanese").addClass("is-visible");
    $(".policy__english").removeClass("is-visible");
  });
  $("#english").click(function () {
    $(this).addClass("is-active");
    $("#japanese").removeClass("is-active");
    $(".policy__english").addClass("is-visible");
    $(".policy__japanese").removeClass("is-visible");
    $(".policy__japanese").removeClass("firstcheck");
  });

  // select 表示非表示
  $(".p-select-change").change(function () {
    var val = $(".p-select-change option:selected").val();
    if (val == ".p-select-change") return;
    $(".p-select-change__cont").addClass("is-hide");
    $(".p-select-change__cont#" + val).removeClass("is-hide");
  });

  //form同意ボタン
  $("#privacy-check").change(function (e) {
    if ($(e.currentTarget).prop("checked")) {
      $(".inquiry-submit .c-btn-type1").removeClass("is-inactive");
    } else {
      $(".inquiry-submit .c-btn-type1").addClass("is-inactive");
    }
  });

  setTimeout(function () {
    $(".k_visual-load").fadeOut();
  }, 3000);

  setTimeout(function () {
    $(".k-visual h1").fadeIn();
  }, 4000);

  //newsList画像枠サイズ処理
  var timer = 0;

  function adjustCardImageSize() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var maxHeight = $(".news__card__img:visible").width() * 0.525;
      var maxHeight2 = $(".top-sect-news__card__img:visible").width() * 0.525;
      $(".news__card__img").css("height", maxHeight);
      $(".top-sect-news__card__img").css("height", maxHeight2);
    }, 200);
  }
  adjustCardImageSize();
  $(window).on("resize", adjustCardImageSize);
});

//urlパラメーター取得
function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// gameページ
$(function () {
  $(".gameOverseas-box").hide();
  $(".game__tab.p-tab-content__tabs a").on("click", (e) => {
    $(".p-tab-content__tabs li").removeClass("is-active");
    $(e.currentTarget).parent().addClass("is-active");
    $(".games__box").hide();
    $(".games__box .is-animated").removeClass("is-animated");
    let boxName = `.${$(e.currentTarget).attr("class")}-box`;
    $(boxName).fadeIn();
    $(boxName + " a").addClass("is-animated");
    e.preventDefault();
  });
});

$(function () {
  $(".company-executive-change").click(function () {
    $(this).nextAll(".company-executive-change__inner").removeClass("is-hide");
  });
  $(".company-executive-change__inner").click(function () {
    $(this).addClass("is-hide");
  });
});

$('select[name="newsYear"]').on("change", function () {
  if (location.pathname.indexOf("/en/") !== -1) {
    if ($(this).val() != "") {
      window.location.href = "/en/news/" + $(this).val();
    }
  } else {
    if ($(this).val() != "") {
      window.location.href = "/news/" + $(this).val();
    }
  }
});


// スムーススクロール
$(function(){
  $('a[href^="#"]').on('click', function(){
    var adjust = 0;
    var speed = 400;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});



// WEBPACK FOOTER //
// ./src/js/app.js